module.exports = __webpack_public_path__ + "assets/france-icon.3d9512c7.svg";